import React from 'react';
import './styles.scss';

function SectionText() {
    return (
        <section className="section-text">
            <div className="container">
                <h3>Take Product with you everywhere you go.</h3>
                <p>Product is all you need. Anywhere - ever. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita sapiente hic voluptatum quo sunt totam accusamus distinctio minus aliquid quis!</p>
            </div>
        </section>
    )
}

export default SectionText;
